import { Route } from '../Routing/types';
import {
  PATH_DAY_PLAN_INDEX_WITH_DATE,
  PATH_DAY_PLAN_MEAL_DETAILS,
  PATH_DAY_PLAN_REPLACE_MEAL,
  PATH_DAY_PLAN_REPLACE_DAY,
  PATH_SHOPPING_LIST,
  PATH_FAV_MEALS,
  PATH_FAV_MEAL_DETAILS,
} from './paths';

import {
  MealPlanIndexPage,
  MealDetailsPage,
  MealReplacementPage,
  DayReplacementPage,
  FavMealsIndexPage,
  FavMealPage,
  ShoppingListIndexPage,
} from '@front-activerse/modules';

import { shoppingTipsArticleId } from '../ShoppingList/consts';
import mealPlanNavigation from '../navigation/mealsNavigation';

import { fetchRemoteConfigFields } from '../Firebase/firebaseRemoteConfig';
import { markNotificationAsClosed, getClosedNotifications } from '../Firebase/firebaseFirestoreDb';

const descendantRoutes: Route[] = [
  {
    path: PATH_DAY_PLAN_INDEX_WITH_DATE,
    element: (
      <MealPlanIndexPage
        mealPlanNavigation={mealPlanNavigation}
        fetchRemoteConfigFields={fetchRemoteConfigFields}
        markNotificationAsClosed={markNotificationAsClosed}
        getClosedNotifications={getClosedNotifications}
      />
    ),
    private: true,
    title: 'meals.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_MEAL_DETAILS,
    element: <MealDetailsPage />,
    private: true,
    title: 'mealPlan.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_REPLACE_MEAL,
    element: <MealReplacementPage />,
    private: true,
    title: 'mealPlan.changeMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_DAY_PLAN_REPLACE_DAY,
    element: <DayReplacementPage />,
    private: true,
    title: 'mealPlan.changeMenu.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_SHOPPING_LIST,
    element: <ShoppingListIndexPage shoppingTipsArticleId={shoppingTipsArticleId} />,
    private: true,
    title: 'shoppingList.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_FAV_MEALS,
    element: <FavMealsIndexPage />,
    private: true,
    title: 'mealPlan.favorites.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: PATH_FAV_MEAL_DETAILS,
    element: <FavMealPage />,
    private: true,
    title: 'mealPlan.favorites.mealDetails.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
